import React from "react";

const TermsAndCondition = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Header Banner */}
      <div className="bg-gradient-to-r from-orange-400 to-orange-700 py-16 text-white text-center shadow-md">
        <h1 className="text-5xl font-extrabold">Terms & Conditions</h1>
        <p className="text-lg mt-2 font-light">
          Read the rules before shopping with Brick & Bar
        </p>
      </div>

      {/* Content */}
      <div className="w-full mx-auto px-6 py-12 text-gray-800">
        {sections.map((section, index) => (
          <div key={index} className="mb-10">
            <h2 className="text-2xl font-semibold mb-3 border-b-2 border-orange-400 pb-1">
              {section.title}
            </h2>
            <p className="text-lg leading-relaxed">{section.content}</p>
          </div>
        ))}

        {/* Last updated */}
        {/* <div className="text-sm text-gray-500 text-right mt-12">
          Last updated: May 13, 2025
        </div> */}
      </div>
    </div>
  );
};

// Terms content (cleanly separated for readability)
const sections = [
  {
    title: "1. Introduction",
    content: `Welcome to Brick & Bar. By using our website, you agree to follow these Terms and Conditions. Please read them carefully before making any purchases.`,
  },
  {
    title: "2. Use of Website",
    content: `You agree to use this website responsibly and not engage in any activity that could damage or disrupt our services.`,
  },
  {
    title: "3. Product Information",
    content: `We strive to provide accurate product details. However, errors may occasionally occur, and we reserve the right to update product information at any time.`,
  },
  {
    title: "4. Orders & Payments",
    content: `All orders are subject to acceptance and availability. You agree to provide accurate billing information and authorize us to charge your chosen payment method.`,
  },
  {
    title: "5. Shipping & Delivery",
    content: `We aim to ship orders promptly. However, we are not liable for delays caused by external shipping providers or unforeseen issues.`,
  },
  {
    title: "6. Returns & Refunds",
    content: `You may return eligible items within our return period. Refunds will be issued using the original payment method after inspection.`,
  },
  {
    title: "7. Intellectual Property",
    content: `All content on this website is owned by Brick & Bar and protected by copyright and intellectual property laws.`,
  },
  {
    title: "8. Limitation of Liability",
    content: `We are not liable for indirect or consequential losses resulting from the use of our site or products.`,
  },
  {
    title: "9. Changes to Terms",
    content: `We may revise these Terms and Conditions at any time. Continued use of the site means you accept the updated terms.`,
  },
];

export default TermsAndCondition;
